import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import plusFill from '@iconify/icons-eva/plus-fill';
import { Icon } from '@iconify/react';
import { filter } from 'lodash';

// material
import { Button, Container, Stack, TablePagination, Typography } from '@mui/material';
// components
import { useState } from 'react';
import Page from '../components/Page';
import { AerosList, AerosImport, AerosSearch } from '../components/Aeros';
import { useTranslation } from '../common/LocalizationProvider';
import { selectAerosArray, selectSession } from '../createSelectorUtils';
//

// ----------------------------------------------------------------------

function applySearch(array, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  if (query) {
    return filter(
      array,
      (item) =>
        item.oaci.toLowerCase().indexOf(query.toLowerCase()) !== -1 ||
        (item.nom !== undefined
          ? item.nom.toLowerCase().indexOf(query.toLowerCase()) !== -1
          : false)
    );
  }
  return stabilizedThis.map((el) => el[0]);
}

export default function Aeros() {
  const t = useTranslation();
  const navigate = useNavigate();
  const session = useSelector(selectSession);
  const aeros = useSelector(selectAerosArray);

  const [search, setSearch] = useState('');
  const handleSearch = (event) => setSearch(event.target.value);

  const searchObject = applySearch(aeros, search);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(24);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <Page title={t('AL_Title')}>
      <Container>
        <Stack>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            marginBottom={5}
          >
            <Typography variant="h6" gutterBottom>
              {t('aerosList')}
            </Typography>
            <Stack direction="column" spacing={1} flexShrink={0} sx={{ my: 1 }}>
              <Button
                variant="contained"
                onClick={() => navigate('add/aeros')}
                startIcon={<Icon icon={plusFill} />}
              >
                {t('new_aeros')}
              </Button>
              {session.administrator && <AerosImport />}
            </Stack>
          </Stack>
          <Stack
            direction="row"
            flexWrap="wrap-reverse"
            alignItems="center"
            justifyContent="flex-end"
            sx={{ mb: 5, mt: 3 }}
          >
            <Stack direction="row" spacing={0} flexShrink={0}>
              <AerosSearch searchName={search} onSearchName={handleSearch} />
            </Stack>
          </Stack>
        </Stack>

        <AerosList
          aeros={searchObject.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)}
        />

        <TablePagination
          rowsPerPageOptions={[24, 100, 252, 500]}
          component="div"
          count={searchObject.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Container>
    </Page>
  );
}
